module.exports = __webpack_public_path__ + "img/独一味.168f077e.jpg";